<script>
export default {
  name: "CurrentSharingButton"
}
</script>

<template>

  <v-btn :disabled="false" :icon="true" :to="{name:'current-sharing'}">
    <v-icon x-large color="primary">
      mdi-share-variant
    </v-icon>
  </v-btn>

</template>

<style scoped lang="scss">

</style>